module.exports = __webpack_public_path__ + "static/img/2.b3400e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/drilling/2.jpg
// module id = vBC+
// module chunks = 1